(function () {


	angular.module('app.widgets')
	.directive('plaValidMonth', plaValidMonth); 

	function plaValidMonth() {
        return {
            require: 'ngModel',
            link: function(scope, elem, attrs, ctrl) {
                if (!ctrl) return;
                ctrl.$validators.validMonth = function(value) {
                    return value && value >= 1 && value <= 12;
                };
            }
        }
    }

})();